class NewsletterPopup {
  button: HTMLButtonElement | null;
  popup: HTMLDivElement | null;
  form: HTMLFormElement | null;

  private isOpen = false;

  constructor(private root: HTMLElement) {
    this.button = this.root.querySelector('.newsletter-banner__more');
    this.popup = this.root.querySelector('.newsletter-popup');
    this.form = this.root.querySelector('.newsletter-popup__form');

    if (this.button && this.popup && this.form) {
      this.init();
    }
  }

  init() {
    this.button!.addEventListener('click', () => this.open());

    this.popup!.addEventListener('click', (e) => {
      if (!this.form!.contains(e.target as Node)) {
        this.close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
  }

  open() {
    this.popup!.hidden = false;
    this.popup!.classList.add('active');
    document.body.classList.add('popup-open');
    this.isOpen = true;
  }

  close() {
     this.popup!.hidden = true;
    this.popup!.classList.remove('active');
    document.body.classList.remove('popup-open');
    this.isOpen = false;
  }
}

document.querySelectorAll<HTMLElement>('.newsletter-banner').forEach((banner) => {
  new NewsletterPopup(banner);
});
